<script setup lang="ts">
import { AppNavItem } from '@libs/ui';

import { useCoreStore } from '../../stores/coreStore';
import SemboLogo from '../SemboLogo.vue';
import { useRouterStore, useStatsigEventsStore } from '../../stores';

interface TheHeaderProps {
  shouldShowPrintButton?: boolean;
}

const props = defineProps<TheHeaderProps>();

const coreStore = useCoreStore();
const routerStore = useRouterStore();
const statsigEventsStore = useStatsigEventsStore();

function navegateToPrintMode(): void {
  statsigEventsStore.logTripOverviewPrintModeOpened({
    source: 'button',
  });
  routerStore.navigateToTripOverviewPrint();
}
</script>

<template>
  <header class="the-header">
    <SemboLogo color="color-sembo-purple" />
    <div class="nav-items">
      <AppNavItem
        v-if="props.shouldShowPrintButton"
        :text="$t('planner.print_trip')"
        @click="navegateToPrintMode"
      />
      <AppNavItem
        :text="$t('planner.support')"
        @click="coreStore.openSupportPage"
      />
    </div>
  </header>
</template>

<style scoped lang="scss">
.the-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--spacing-24);
  .nav-items {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: var(--spacing-24);
  }

  @include for-less-or-equal-than-599-px {
    .the-header {
      padding: 0 var(--spacing-16);
    }
  }
}
</style>
